import type { AllCustomerDetailOpenPosition, ExternWarengruppen } from "@/shared-types";
import { formatDateOnly } from "./dateUtil";

const baseAPIPath = "/api/external";

export async function listAll() {
  const res = await fetch(`${baseAPIPath}/list`, {
    method: "GET",
  });
  const response = (await res.json()) as ExternWarengruppen[];
  return response;
}

export async function user() {
  const json = await fetch(`${baseAPIPath}/user`, {
    method: "GET",
  });
  if (json.status === 401) {
    throw new Error("Unauthorized");
  }
  const response = (await json.json()) as {
    name: string;
    email: string;
    allowedCountries: string[];
  };
  return response;
}

export async function allCustomer() {
  const userInfo = await user();
  const allowedCountries = userInfo.allowedCountries;

  let selectedCountry = null;
  if (localStorage.getItem("forceBenelux") === "true" && allowedCountries.includes("benelux")) {
    selectedCountry = "benelux";
  } else if (
    localStorage.getItem("forceFrance") === "true" &&
    allowedCountries.includes("france")
  ) {
    selectedCountry = "france";
  } else if (
    localStorage.getItem("forceRussia") === "true" &&
    allowedCountries.includes("russia")
  ) {
    selectedCountry = "russia";
  } else if (
    localStorage.getItem("forcePoland") === "true" &&
    allowedCountries.includes("poland")
  ) {
    selectedCountry = "poland";
  }

  const headers: HeadersInit = {};
  if (selectedCountry) {
    headers.vertretercountry = selectedCountry;
  }

  const result = await fetch(`${baseAPIPath}/all-customer`, {
    method: "GET",
    headers,
  });
  return await result.json();
}

export async function allCustomerDetail() {
  const userInfo = await user();
  const allowedCountries = userInfo.allowedCountries;

  let selectedCountry = null;
  if (localStorage.getItem("forceBenelux") === "true" && allowedCountries.includes("benelux")) {
    selectedCountry = "benelux";
  } else if (
    localStorage.getItem("forceFrance") === "true" &&
    allowedCountries.includes("france")
  ) {
    selectedCountry = "france";
  } else if (
    localStorage.getItem("forceRussia") === "true" &&
    allowedCountries.includes("russia")
  ) {
    selectedCountry = "russia";
  } else if (
    localStorage.getItem("forcePoland") === "true" &&
    allowedCountries.includes("poland")
  ) {
    selectedCountry = "poland";
  }

  const headers: HeadersInit = {};
  if (selectedCountry) {
    headers.vertretercountry = selectedCountry;
  }

  const result = await fetch(`${baseAPIPath}/all-customer-detail`, {
    method: "GET",
    headers,
  });
  return await result.json();
}

export async function downloadExcelOrders(
  setLoading: (loading: boolean) => void,
  open: AllCustomerDetailOpenPosition[],
  kundennummer: string
) {
  const userInfo = await user();
  const allowedCountries = userInfo.allowedCountries;

  let selectedCountry = null;
  if (localStorage.getItem("forceBenelux") === "true" && allowedCountries.includes("benelux")) {
    selectedCountry = "benelux";
  } else if (
    localStorage.getItem("forceFrance") === "true" &&
    allowedCountries.includes("france")
  ) {
    selectedCountry = "france";
  } else if (
    localStorage.getItem("forceRussia") === "true" &&
    allowedCountries.includes("russia")
  ) {
    selectedCountry = "russia";
  } else if (
    localStorage.getItem("forcePoland") === "true" &&
    allowedCountries.includes("poland")
  ) {
    selectedCountry = "poland";
  }

  const headers: HeadersInit = {};
  if (selectedCountry) {
    headers.vertretercountry = selectedCountry;
  }

  setLoading(true);
  const response = await fetch(`${baseAPIPath}/all-customer-detail/excel-orders`, {
    method: "POST",
    body: JSON.stringify(open),
    headers,
  });

  const blob = await response.blob();
  const url = window.URL.createObjectURL(new Blob([blob]));
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute(
    "download",
    `orders_${kundennummer}_${formatDateOnly(new Date()).replace(", ", "_")}.xlsx`
  );
  document.body.appendChild(link);
  link.click();
  link.parentNode?.removeChild(link);
  setLoading(false);
}
